/* Progressive enhancement: works for initial markup and AJAX cart replacements. */
if (!customElements.get('sfx-eu-notice')) {
  customElements.define('sfx-eu-notice', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.sfx-eu__open');
      if (!dialog || !opener || typeof dialog.showModal !== 'function') return;
      this.initialized = true;
      opener.setAttribute('aria-haspopup', 'dialog');
      const image = dialog.querySelector('img');
      opener.addEventListener('click', (event) => {
        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (!image.getAttribute('src')) image.src = image.dataset.src;
        if (!dialog.open) dialog.showModal();
      });
      dialog.querySelector('.sfx-eu__close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right ||
            event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog && dialog.open) dialog.close();
    }
  });
}
